/**
 * How a stored status is SHOWN: Title Case words ("approved" -> "Approved", "partially_paid" -> "Partially Paid"). Presentation only -- the stored
 * value and every rule that reads it are unchanged.
 */
export const statusLabel = (status: string | null | undefined): string =>
  String(status ?? '')
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
